import engravingPrinting from "./templates/engraving-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>
          Спортивная бутылка – прекрасный функциональный подарок для любителей активного образа жизни. 
          Мягкая на ощупь поверхность софт-тач, и эргономичная форма бутылки делают её использование невероятно приятным. 
          Сама бутылка сделана из нержавеющей стали, а в пластиковой крышке предусмотрено специальное отверстие для питья, так что пить из неё можно не только на ходу, но и на бегу.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${engravingPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
